var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ColumnTitle flex items-end relative font-bold"},[_c('p',[_vm._v(" "+_vm._s(_vm.title || _vm.$route.meta.title)+" ")]),(_vm.total !== 0)?_c('p',{staticClass:"total ml-4 text-lg font-bold"},[_vm._v(" "+_vm._s(_vm.total)+"条数据 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }